import React, { useState } from 'react';
import MssModal from '../MssModal';
import FeedbackButton from './FeedbackButton';
import FeedbackForm from './FeedbackForm';

/**
 * Asks what people make of myStudySidekick, from wherever they are in it.
 *
 * Rendered once per shell — the Canvas pages and the developer portal each
 * mount one — rather than per page, so the way to say something is in the same
 * place throughout and no page has to remember to offer it.
 */
function Feedback({ id = 'feedback' }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <FeedbackButton id={id} onClick={() => setIsOpen(true)} />

      <MssModal
        id={`${id}__modal`}
        className="mss__feedbackModal"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        isCloseable
        title="myStudySidekick Feedback"
        maxWidth="sm"
      >
        {/*
          Keyed on each opening, so a form that was filled in and sent does not
          greet the next visit with the thank-you it ended on.
        */}
        <FeedbackForm key={String(isOpen)} id={id} />
      </MssModal>
    </>
  );
}

export default Feedback;
